import axiosAPI from '../middlewares/axios-interceptor';
import { ISignupOtpPayload } from '../models/Types';

const signup = (data: any) => axiosAPI.post('/newuser', data);
const userinfo = (data:any)=>axiosAPI.post('/user-info-verify',data);
const userDatainfo=(data:any)=>axiosAPI.post('/user-data-verify',data);
const getotpsignupbyemail = ({ serviceCode, ...data }: ISignupOtpPayload)=>axiosAPI.post('/twoFactorAuthenticationByEmail',data);
const getotpsignupbysms = ({ serviceCode, ...data }: ISignupOtpPayload)=>axiosAPI.post('/twoFactorAuthenticationBySms',data);
const newUserverifybyemail=(data:any)=>axiosAPI.post('/newUserverifybyemail',data);
const newUserverifybysms=(data:any)=>axiosAPI.post('/newUserverifybysms',data);
export {
    signup,
    userinfo,
    userDatainfo,
    getotpsignupbyemail,
    getotpsignupbysms,
    newUserverifybyemail,
    newUserverifybysms,
};
